export const INQUIRY_KEYS = {
  INQUIRIES_LIST: "inquiries_list",
};
